'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Cell = exports.Table = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _templateObject = _taggedTemplateLiteral(['\n  display: grid;\n  background-color: rgba( 0, 0, 0, 0.5 );\n  grid-row-gap: 1px;\n  grid-column-gap: 1px;\n  padding: 1px;\n  justify-items: stretch;\n'], ['\n  display: grid;\n  background-color: rgba( 0, 0, 0, 0.5 );\n  grid-row-gap: 1px;\n  grid-column-gap: 1px;\n  padding: 1px;\n  justify-items: stretch;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  background-color: #fff;\n  padding: 12px 7px;\n\n  ', '\n'], ['\n  background-color: #fff;\n  padding: 12px 7px;\n\n  ', '\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n    cursor: pointer;\n\n    &:hover {\n      background-color: #EEEEEE;\n    }\n  '], ['\n    cursor: pointer;\n\n    &:hover {\n      background-color: #EEEEEE;\n    }\n  ']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components/dist/styled-components.js');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Table = (0, _styledComponents2.default)(function (_ref) {
  var columns = _ref.columns,
      _ref$style = _ref.style,
      style = _ref$style === undefined ? {} : _ref$style,
      props = _objectWithoutProperties(_ref, ['columns', 'style']);

  return _react2.default.createElement('div', _extends({
    style: _extends({
      gridTemplateColumns: columns
    }, style)

  }, props));
})(_templateObject);

exports.Table = Table;
var Cell = (0, _styledComponents2.default)(function (_ref2) {
  var header = _ref2.header,
      row = _ref2.row,
      column = _ref2.column,
      span = _ref2.span,
      rowSpan = _ref2.rowSpan,
      _ref2$number = _ref2.number,
      number = _ref2$number === undefined ? false : _ref2$number,
      style = _ref2.style,
      props = _objectWithoutProperties(_ref2, ['header', 'row', 'column', 'span', 'rowSpan', 'number', 'style']);

  return _react2.default.createElement('div', _extends({
    style: _extends({
      gridColumn: column + ' / span ' + (span || 1),
      gridRow: row + ' / span ' + (rowSpan || 1),

      color: 'rgba( 0, 0, 0, ' + (header || row === 1 ? 0.7 : 0.9) + ' )',
      fontWeight: '' + (header || row === 1 ? 'bold' : 'normal'),
      fontSize: (header || row === 1 ? 14 : 15) + 'px',
      textAlign: number && 'right'

    }, style)
  }, props));
})(_templateObject2, function (props) {
  return props.onClick && (0, _styledComponents.css)(_templateObject3);
});
exports.Cell = Cell;


//////////////////
// WEBPACK FOOTER
// ./table/components.js
// module id = 611
// module chunks = 0